import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/capture.png'
import _imports_1 from '../../images/delete_icon.png'
import _imports_2 from '../../images/img_top-up_success.png'


const _withScopeId = n => (_pushScopeId("data-v-4714770e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "create-image" }
const _hoisted_2 = {
  key: 0,
  class: "info"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "上传图片"
  }),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","margin-top":"16px","font-weight":"400","color":"#1D1D1D"} }, "上传身份证头像面")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-cover van-ellipsis" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "上传图片"
  }),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","margin-top":"16px","font-weight":"400","color":"#1D1D1D"} }, "上传身份证国徽面")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-cover van-ellipsis" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "info",
  style: {"margin-top":"86px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"500","color":"#000000","margin-top":"22px"} }, "您已成功上传 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"400","color":"#9D9D9D","font-size":"14px","margin-top":"12px"} }, "请等待电脑端同步上传结果", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "btn-box"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "diaTitle" }, "营业执照上传须知")
], -1))
const _hoisted_14 = { style: {"margin":"10px 14px","border-bottom":"1px solid #ECECEC","position":"relative"} }
const _hoisted_15 = {
  key: 0,
  class: "orangeTitle"
}
const _hoisted_16 = { class: "linearGradient" }
const _hoisted_17 = { class: "dialogHead" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialogTitle" }, "识别失败", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialogBac" }, null, -1))
const _hoisted_20 = { class: "dialogText" }

import { watch, onMounted, reactive, ref ,onActivated} from "vue";
import axios from 'axios';
import { message } from "ant-design-vue"
import {extractUrlQueryParams, fileToBase64WithName} from '../../utils'

export default /*#__PURE__*/_defineComponent({
  __name: 'uploadYsSfz',
  setup(__props) {

const imgf = require('../../images/img_id_card_1.png')
const imgb = require('../../images/img_id_card_2.png')
const show = ref(false)
const body = ref<any>(null)
const imgIndex = ref(0);
const fileList = ref([]as string[]);
const fileListBc = ref ([]as string[]);
const successFlag = ref(false)
const canSubmit = ref(false)
onMounted(() => {
  document.title = '拍照上传'
})
const imagePreview = ref([imgb,imgf])
const loadingUp = ref(false);
const picLoading = ref(false);
const titleList = ['提示一','提示二','提示三','提示四'];
const bannerList = ['提示一','提示二','提示三','提示四'];
const onChange = (newIndex:any) => {
  imgIndex.value = newIndex;
};
const showDialog = ref(false);
const showBottom = ref(false);
const activeTitle = ref('');
const activeBanner = ref('');
const showHelpTips = ref('');
const removeSuffixIfPresent = (str:any) =>  {
  return str.replace("https://c1.yaofangwang.net/", "");
}
const showImg =()=>{
  show.value = true;
}
const underRules = ()=>{
  canSubmit.value = true;
  showBottom.value = false;
}
const resetPic =()=>{
  fileList.value = [];
  fileListBc.value = [];
  showDialog.value = false;
}
const hasMounted = ref(false)

const submit = async () => {
  if(picLoading.value){
    message.warning('请等待图片上传完成后提交');
    return
  }
  if(!fileList.value||!fileList.value.length||!fileListBc.value||!fileListBc.value.length){
    return
  }
  let arr:any = []
  fileList.value.forEach(item=>{
    if(item&&item.url){
      arr.push(removeSuffixIfPresent(item.url))
    }
  })
  let err:any = []
  fileListBc.value.forEach(item=>{
    if(item&&item.url){
      err.push(removeSuffixIfPresent(item.url))
    }
  })
  let imageUrl = arr.join(',')
  let imageUrlBc = err.join(',')
  const params = extractUrlQueryParams(window.location.href);
  const postData = new FormData();
  postData.append("shopId", params.shopId)
  postData.append("imageUrl", imageUrl)
  postData.append("ssid", params.ssid)
  postData.append("type",'0')
  const postDataBc = new FormData();
  postDataBc.append("shopId", params.shopId)
  postDataBc.append("imageUrl", imageUrlBc)
  postDataBc.append("ssid", params.ssid)
  postDataBc.append("type",'1')
  loadingUp.value = true;
  axios.post('https://api-erp.yaofangwang.com/merchantSettle.common.idCardOcrForH5', postData)
    .then((response) => {
      if (response.data?.code == 1) {
        axios.post('https://api-erp.yaofangwang.com/merchantSettle.common.idCardOcrForH5', postDataBc)
        .then((response) => {
          if (response.data?.code == 1) {
            loadingUp.value = false;
            successFlag.value = true;
          }else {
            showHelpTips.value = response.data.msg?response.data.msg: response.data.result?.failMessage || '请确认拍摄完整，光线充足！'
            showDialog.value = true;
          }
          loadingUp.value = false;
        })
        .catch((error) => {
          loadingUp.value = false;
          showHelpTips.value = '请确认拍摄完整，光线充足！'
          showDialog.value = true;
        });
      }else {
        
        showHelpTips.value = response.data.msg?response.data.msg: response.data.result?.failMessage || '请确认拍摄完整，光线充足！'
        showDialog.value = true;
      }
      loadingUp.value = false;
    })
    .catch((error:any) => {
      loadingUp.value = false;
      showHelpTips.value = '请确认拍摄完整，光线充足！'
      showDialog.value = true;
    });
}
const beforeRead = async (file:any) => {
  // 检查文件类型
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('只能上传jpg或png格式的图片！');
    return Promise.reject(file);
  }

  // 检查文件大小
  const isLt2M = file.size / 1024 / 1024 < 5;
  if (!isLt2M) {
    message.error('图片大小不能超过5MB！');
    return Promise.reject(file);
  }
  
};
const afterRead = async (filelist:any) => {
  filelist.status = 'uploading';
  filelist.message = '上传中...';
  const {file} = filelist;
  picLoading.value = true;
  try {
    const formData = new FormData();
    // formData.append('file', file); // 假设服务器接口期望接收名为'file'的字段
    const {fileName , base64} = await fileToBase64WithName(file)
    const params = extractUrlQueryParams(window.location.href);
    formData.append("ssid", params.ssid)
    formData.append('fileName',fileName);
    formData.append("fileBase64",base64)

    // 发起 POST 请求进行文件上传
    const response = await axios.post('https://api-erp.yaofangwang.com/common.handle.uploadForH5', formData, {
      headers: {
        // 'Content-Type': 'multipart/form-data', // 设置正确的Content-Type
      },
    });
    console.log(response,'response')
    if (response.status === 200&& response.data.code === 1) {
      filelist.status = 'success';
      filelist.message = '';
      // 上传成功，将返回的 URL 添加到 fileList
      fileList.value[0].url ='https://c1.yaofangwang.net/'+ response.data.result ;
      message.success('上传成功');
    } else {
      fileList.value = [];
      message.error('上传失败,请重试');
    }
  } catch (error) {
    console.log(error,'error')
    message.error('上传失败,请重试');
    picLoading.value = false;
    fileList.value = [];
  } finally {
    picLoading.value = false;
  }
};
const afterReadBc = async (filelist:any) => {
  filelist.status = 'uploading';
  filelist.message = '上传中...';
  const {file} = filelist;
  picLoading.value = true;
  try {
    const formData = new FormData();
    const {fileName , base64} = await fileToBase64WithName(file)
    const params = extractUrlQueryParams(window.location.href);
    formData.append("ssid", params.ssid)
    formData.append('fileName',fileName);
    formData.append("fileBase64",base64)

    // 发起 POST 请求进行文件上传
    const response = await axios.post('https://api-erp.yaofangwang.com/common.handle.uploadForH5', formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // 设置正确的Content-Type
      },
    });

    if (response.status === 200&& response.data.code === 1) {
      filelist.status = 'success';
      filelist.message = '';
      // 上传成功，将返回的 URL 添加到 fileList
      fileListBc.value[0].url ='https://c1.yaofangwang.net/'+ response.data.url ;
      message.success('上传成功');
    } else {
      message.error('上传失败,请重试');
      fileListBc.value = [];
    }
  } catch (error) {
    message.error('上传失败,请重试');
    picLoading.value = false;
    fileListBc.value = [];
  } finally {
    picLoading.value = false;
  }
};
const onChangeSwipe = (index:any)=>{
  activeTitle.value = titleList[index];
  activeBanner.value = bannerList[index];
}
const showRules = ()=>{
  showBottom.value = true;
  activeTitle.value = titleList[0];
  activeBanner.value = bannerList[0];
}
onMounted(()=>{
  // if(!hasMounted.value){
  //   console.log(12,123)
  //   hasMounted.value = true;
  //   showRules()
  // }
})


return (_ctx: any,_cache: any) => {
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_image_preview = _resolveComponent("van-image-preview")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mobile-content",
    ref: (ref) => (body.value = ref)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!successFlag.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", { class: "tipInfo" }, [
              _createElementVNode("span", { onClick: showImg }, "查看示例")
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_van_uploader, {
                modelValue: fileList.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event)),
                "max-count": 1,
                "before-read": beforeRead,
                "after-read": afterRead,
                id: fileList.value&&fileList.value[0]&&fileList.value[0].status == 'success'?'noBac':''
              }, {
                "preview-cover": _withCtx(({ file }) => [
                  _hoisted_4
                ]),
                "preview-delete": _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_1,
                    style: {"width":"24px","position":"absolute","right":"-8px","top":"0","cursor":"pointer"},
                    alt: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (fileList.value = []))
                  })
                ]),
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["modelValue", "id"]),
              _createVNode(_component_van_uploader, {
                style: {"margin-top":"32px"},
                id: fileListBc.value&&fileListBc.value[0]&&fileListBc.value[0].status == 'success'?'noBac':'sfcbc',
                modelValue: fileListBc.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fileListBc).value = $event)),
                "max-count": 1,
                "before-read": beforeRead,
                "after-read": afterReadBc
              }, {
                "preview-cover": _withCtx(({ file }) => [
                  _hoisted_6
                ]),
                "preview-delete": _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_1,
                    style: {"width":"24px","position":"absolute","right":"-8px","top":"0","cursor":"pointer"},
                    alt: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (fileListBc.value = []))
                  })
                ]),
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["id", "modelValue"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11)),
      (!successFlag.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: submit,
              class: _normalizeClass(!fileList.value.length||!fileListBc.value.length?'hidTransf':''),
              loading: loadingUp.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            }, 8, ["class", "loading"])
          ]))
        : _createCommentVNode("", true),
      (showBottom.value)
        ? (_openBlock(), _createBlock(_component_van_popup, {
            key: 3,
            show: showBottom.value,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showBottom).value = $event)),
            round: "",
            position: "bottom",
            closeable: "",
            style: { height: '384px',display:'flex',flexDirection: 'column'}
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_van_swipe, {
                  style: {"height":"260px"},
                  vertical: "",
                  autoplay: "5000",
                  loop: "",
                  onChange: onChangeSwipe
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_swipe_item, null, {
                      default: _withCtx(() => [
                        _createTextVNode("1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_swipe_item, null, {
                      default: _withCtx(() => [
                        _createTextVNode("2")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_swipe_item, null, {
                      default: _withCtx(() => [
                        _createTextVNode("3")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_swipe_item, null, {
                      default: _withCtx(() => [
                        _createTextVNode("4")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (activeTitle.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(activeTitle.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, _toDisplayString(activeBanner.value), 1)
              ]),
              _createVNode(_component_a_button, {
                style: {"margin":"0px 14px"},
                type: "primary",
                onClick: underRules
              }, {
                default: _withCtx(() => [
                  _createTextVNode("我已知晓规则，开始拍摄")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_dialog, {
      show: showDialog.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event)),
      title: "",
      showConfirmButton: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_van_icon, {
            name: "cross",
            size: "13",
            class: "dialogClose",
            onClick: resetPic
          }),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, _toDisplayString(showHelpTips.value), 1),
        _createVNode(_component_van_button, {
          beforeClose: resetPic,
          type: "primary",
          style: {"width":"240px","margin":"20px 0px 0px 0px"},
          onClick: resetPic
        }, {
          default: _withCtx(() => [
            _createTextVNode("重新拍摄")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_image_preview, {
      show: show.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((show).value = $event)),
      images: imagePreview.value,
      onChange: onChange
    }, {
      index: _withCtx(() => [
        _createTextVNode(_toDisplayString(imgIndex.value+1+'/'+imagePreview.value.length), 1)
      ]),
      _: 1
    }, 8, ["show", "images"])
  ], 512))
}
}

})